import { render, staticRenderFns } from "./detailFollowUpRecord.vue?vue&type=template&id=1e1e9036&scoped=true&"
import script from "./detailFollowUpRecord.vue?vue&type=script&lang=js&"
export * from "./detailFollowUpRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailFollowUpRecord.vue?vue&type=style&index=0&id=1e1e9036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e9036",
  null
  
)

export default component.exports